import React from 'react';
import { useLinesContext } from '../../../contexts/Lines';
import DotHelpTip from '../DotHelpTip/DotHelpTip';
import makeStyles from '@material-ui/core/styles/makeStyles';
import messages from '../../../messages';

const useStyles = makeStyles((theme: any) => ({
  helptip: {
    position: 'absolute',
    right: -4,
    top: -4,
    zIndex: 1000,
  },
}));

export default function OnboardingHelpTip() {
  const classes = useStyles();
  const { lines, isCreatingFirst3Lines } = useLinesContext();

  const creatingFirst3Lines = isCreatingFirst3Lines();

  return (
    <>
      {creatingFirst3Lines && (
        <div className={classes.helptip}>
          <DotHelpTip
            text={messages.lines.onboarding.createMoreLines(3 - lines?.length)}
          />
        </div>
      )}
    </>
  );
}
